import {} from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import * as actionTypes from '../constants/spoke';

import { updateObject } from '../../../../shared/utils/utility';

import { AppAction } from '../../../../store';

import { SpokeAccount } from '../../models';

export type SpokeState = {
  spokeAccount: SpokeAccount | null;
  spokeAccountError: any | null;
  spokeAccountLoading: boolean;

  saveSpokeAccount: boolean | null;
  saveSpokeAccountError: any | null;
  saveSpokeAccountLoading: boolean;

  deleteSpokeAccountResult: boolean | null;
  deleteSpokeAccountError: any | null;
  deleteSpokeAccountLoading: boolean;

  webhookUrl: string | null;
  webhookUrlError: any | null;
  webhookUrlLoading: boolean;
};

const initialState: SpokeState = {
  spokeAccount: null,
  spokeAccountError: null,
  spokeAccountLoading: false,
  saveSpokeAccount: null,
  saveSpokeAccountError: null,
  saveSpokeAccountLoading: false,
  deleteSpokeAccountResult: null,
  deleteSpokeAccountError: null,
  deleteSpokeAccountLoading: false,
  webhookUrl: null,
  webhookUrlError: null,
  webhookUrlLoading: false,
};

const getSpokeAccountStart = (state: SpokeState, action: AppAction<SpokeAccount>) => {
  return updateObject(state, {
    spokeAccountError: null,
    spokeAccountLoading: true,
  });
};

const getSpokeAccountSuccess = (state: SpokeState, action: AppAction<SpokeAccount>) => {
  return updateObject(state, {
    spokeAccount: action.data,
    spokeAccountError: null,
    spokeAccountLoading: false,
  });
};

const getSpokeAccountFail = (state: SpokeState, action: AppAction<SpokeAccount>) => {
  return updateObject(state, {
    spokeAccount: null,
    spokeAccountError: action.error,
    spokeAccountLoading: false,
  });
};

const saveSpokeAccountStart = (state: SpokeState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveSpokeAccountError: null,
    saveSpokeAccountLoading: true,
  });
};

const saveSpokeAccountSuccess = (state: SpokeState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveSpokeAccount: action.data,
    saveSpokeAccountError: null,
    saveSpokeAccountLoading: false,
  });
};

const saveSpokeAccountFail = (state: SpokeState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveSpokeAccount: null,
    saveSpokeAccountError: action.error,
    saveSpokeAccountLoading: false,
  });
};

const deleteSpokeAccountStart = (state: SpokeState, action: AppAction<boolean>) => {
  return updateObject(state, {
    deleteSpokeAccountError: null,
    deleteSpokeAccountLoading: true,
  });
};

const deleteSpokeAccountSuccess = (state: SpokeState, action: AppAction<boolean>) => {
  return updateObject(state, {
    spokeAccount: null,
    deleteSpokeAccountResult: action.data,
    deleteSpokeAccountError: null,
    deleteSpokeAccountLoading: false,
  });
};

const deleteSpokeAccountFail = (state: SpokeState, action: AppAction<boolean>) => {
  return updateObject(state, {
    deleteSpokeAccountResult: null,
    deleteSpokeAccountError: action.error,
    deleteSpokeAccountLoading: false,
  });
};

const getWebhookUrlStart = (state: SpokeState, action: AppAction<string>) => {
  return updateObject(state, {
    webhookUrl: null,
    webhookUrlError: null,
    webhookUrlLoading: true,
  });
};

const getWebhookUrlSuccess = (state: SpokeState, action: AppAction<string>) => {
  return updateObject(state, {
    webhookUrl: action.data,
    webhookUrlError: null,
    webhookUrlLoading: false,
  });
};

const getWebhookUrlFail = (state: SpokeState, action: AppAction<string>) => {
  return updateObject(state, {
    webhookUrl: null,
    webhookUrlError: action.error,
    webhookUrlLoading: false,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.SPOKE_GET_SPOKE_ACCOUNT_START:
      return getSpokeAccountStart(state, action as AppAction<SpokeAccount>);
    case actionTypes.SPOKE_GET_SPOKE_ACCOUNT_SUCCESS:
      return getSpokeAccountSuccess(state, action as AppAction<SpokeAccount>);
    case actionTypes.SPOKE_GET_SPOKE_ACCOUNT_FAIL:
      return getSpokeAccountFail(state, action as AppAction<SpokeAccount>);

    case actionTypes.SPOKE_SAVE_SPOKE_ACCOUNT_START:
      return saveSpokeAccountStart(state, action as AppAction<boolean>);
    case actionTypes.SPOKE_SAVE_SPOKE_ACCOUNT_SUCCESS:
      return saveSpokeAccountSuccess(state, action as AppAction<boolean>);
    case actionTypes.SPOKE_SAVE_SPOKE_ACCOUNT_FAIL:
      return saveSpokeAccountFail(state, action as AppAction<boolean>);

    case actionTypes.SPOKE_DELETE_SPOKE_ACCOUNT_START:
      return deleteSpokeAccountStart(state, action as AppAction<boolean>);
    case actionTypes.SPOKE_DELETE_SPOKE_ACCOUNT_SUCCESS:
      return deleteSpokeAccountSuccess(state, action as AppAction<boolean>);
    case actionTypes.SPOKE_DELETE_SPOKE_ACCOUNT_FAIL:
      return deleteSpokeAccountFail(state, action as AppAction<boolean>);

    case actionTypes.SPOKE_GET_WEBHOOK_URL_START:
      return getWebhookUrlStart(state, action as AppAction<string>);
    case actionTypes.SPOKE_GET_WEBHOOK_URL_SUCCESS:
      return getWebhookUrlSuccess(state, action as AppAction<string>);
    case actionTypes.SPOKE_GET_WEBHOOK_URL_FAIL:
      return getWebhookUrlFail(state, action as AppAction<string>);

    default:
      return state;
  }
};

export default reducer;
